import { useState, useEffect, useImperativeHandle } from "react";
import { useTranslation } from "next-i18next";
import { Modal, Button } from "antd";
import Image from "next/image";
import { useAppSelector } from "@/store/hooks";
import { RootState } from "@/store/index";
import defaultSettings from "@/config/settings";

/**
 * success tip modal
 * @param onRef ref
 * @param imgSrc 图片 src
 * @param desc 描述文本
 * @param autoClose 自动关闭
 * @param onConfirm 确定回调
 * @returns
 */
const SuccessTipModal = ({
  onRef,
  imgSrc,
  desc,
  autoClose = false,
  onConfirm,
}: {
  onRef: any;
  imgSrc: string;
  desc: string;
  autoClose?: boolean;
  onConfirm?: () => void;
}) => {
  const { t } = useTranslation();
  const [open, setOpen] = useState<boolean>(false);
  const appStore = useAppSelector((state: RootState) => state.app);
  const { isSmallScreen } = appStore;
  const { pcModalWidth, mobileModalWidth } = defaultSettings;
  const [closeTime, setCloseTime] = useState<number>(5);

  useImperativeHandle(onRef, () => {
    return {
      setOpen: setOpen,
    };
  });

  useEffect(() => {
    let timer;
    if (open && autoClose) {
      timer = setInterval(() => {
        if (closeTime > 1) {
          setCloseTime(closeTime - 1);
        } else {
          clearInterval(timer);
          onConfirm ? onConfirm() : setOpen(false);
        }
      }, 1000);
    }

    if (!open && autoClose) {
      setCloseTime(5);
    }

    return () => {
      if (timer) clearInterval(timer);
    };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open, autoClose, closeTime]);

  // auto close tip
  const AutoCloseTip = (
    <span className="ml-1">
      ({t("common.auto_close_desc1")} {closeTime} {t("common.auto_close_desc2")}
      )
    </span>
  );

  return (
    <Modal
      title={null}
      open={open}
      footer={null}
      centered
      width={isSmallScreen ? mobileModalWidth : pcModalWidth}
      closeIcon={null}
      maskClosable={autoClose}
      onCancel={() => {
        setOpen(false);
      }}
    >
      <div className="flex h-[175px] lg:h-[205px] flex-col items-center">
        <Image
          src={imgSrc}
          title="cart"
          alt="cart"
          width={164}
          height={164}
          className="mb-[30px] mt-[-128px]"
        />
        <div className="mb-12 text-xl text-stone-800">{desc}</div>
        <Button
          type="primary"
          className="min-w-[80px]"
          onClick={() => {
            onConfirm ? onConfirm() : setOpen(false);
          }}
          style={{ height: "36px" }}
        >
          {t("common.ok")} {autoClose && AutoCloseTip}
        </Button>
      </div>
    </Modal>
  );
};

export default SuccessTipModal;
